/**
 * Naming rule for NEW projects (mirrors backend `validateNewProjectName` —
 * keep messages in sync): start with a lowercase letter, then lowercase
 * letters, digits, hyphens, or underscores. 1–64 characters. No capitals,
 * spaces, or other special characters.
 */
export const PROJECT_NAME_CREATION_PATTERN = /^[a-z][a-z0-9_-]{0,63}$/

export function validateProjectName(raw: string | undefined): string | null {
  const name = raw?.trim() ?? ''
  if (name.length === 0) {
    return 'Project name is required.'
  }
  if (name.length > 64) {
    return 'Project name must be 1–64 characters.'
  }
  if (/\s/.test(name)) {
    return 'Spaces are not allowed. Use hyphens or underscores instead (e.g. my-project, my_project).'
  }
  if (/^[0-9]/.test(name)) {
    return 'Project name must start with a letter, not a number.'
  }
  if (/[A-Z]/.test(name)) {
    return 'Capital letters are not allowed. Use lowercase only (e.g. my-project).'
  }
  if (/^[^a-z]/.test(name)) {
    return 'Project name must start with a lowercase letter. Special characters are not allowed as the first character.'
  }
  if (/[^a-z0-9_-]/.test(name)) {
    return 'Only lowercase letters, digits, hyphens, and underscores are allowed (e.g. my-project, my_project).'
  }
  if (!PROJECT_NAME_CREATION_PATTERN.test(name)) {
    return 'Invalid project name. Use lowercase letters, digits, hyphens, or underscores, starting with a letter (e.g. my-project).'
  }
  return null
}
